/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Pll_New_Err_Material_LotInputs */

const vi_pll_new_err_material_lot = /** @type {(inputs: Pll_New_Err_Material_LotInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Chọn lô vật tư`)
};

/**

* @param {Pll_New_Err_Material_LotInputs} inputs
* @param {{ locale?: "vi" }} options
* @returns {LocalizedString}
*/
export const pll_new_err_material_lot = /** @type {((inputs?: Pll_New_Err_Material_LotInputs, options?: { locale?: "vi" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Pll_New_Err_Material_LotInputs, { locale?: "vi" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return vi_pll_new_err_material_lot(inputs)
});